import AddIcon from "@mui/icons-material/Add";
import IconButton, { type IconButtonProps } from "@mui/material/IconButton";
import React from "react";

import { useTranslation } from "~contexts/I18nContext/I18nContext.tsx";

import styles from "./Buttons.module.scss";

interface AddButtonProps extends IconButtonProps {
  title?: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

function AddButton({ title, onClick, ...iconButtonProps }: AddButtonProps) {
  const t = useTranslation();
  const tooltip = title ? t.addResource.replace("{resource}", title) : t.add;
  return (
    <IconButton
      {...iconButtonProps}
      className={styles.button}
      size="small"
      title={tooltip}
      onClick={onClick}
    >
      <AddIcon fontSize="small" />
    </IconButton>
  );
}

const MemoizedAddButton = React.memo(AddButton);

export { MemoizedAddButton as AddButton };
